import * as ProductType from "enums/ProductType"
import { Card, CardContent } from "components/Card"
import { Text } from "components/Text"
import { useTranslator } from "components/Translator"
import { Price } from "components/Price"
import { Discount } from "components/Discount"
import { Image } from "components/Image"

export const ProductCard = ({ product }) => {
  const [type] = product.types

  switch (type.enum_value) {
    case ProductType.PRODUCT:
      return <GenericProductCard product={product} />

    case ProductType.FLOTILLA:
      return <FlotillaCard product={product} />

    case ProductType.BENEFIT:
      return <BenefitCard product={product} />

    default:
      throw new Error(`Unkown product type: ${type}`)
  }
}

const BenefitCard = ({ product }) => {
  return (
    <Card spacing="small">
      <CardContent>
        <ProductImage product={product} />
      </CardContent>
      <CardContent>
        <div className="space-y-2">
          <ProductTitle product={product} />
          <Discount amount={product.purchaseExternalDiscount} />
        </div>
      </CardContent>
    </Card>
  )
}

const FlotillaCard = ({ product }) => {
  const translator = useTranslator()

  return (
    <Card spacing="small">
      <CardContent>
        <ProductImage product={product} />
      </CardContent>
      <CardContent>
        <div className="space-y-2">
          <ProductTitle product={product} />
          {product.event ? (
            <Text variant="caption" className="text-light">
              {translator.trans(
                "ProductCard.flotilla.dateInterval",
                {
                  from: new Date(
                    product.event.dateInterval.from,
                  ).toLocaleDateString(product.locale),
                  to: new Date(
                    product.event.dateInterval.to,
                  ).toLocaleDateString(translator.locale),
                },
                "components",
              )}
            </Text>
          ) : null}
        </div>
      </CardContent>
    </Card>
  )
}

const GenericProductCard = ({ product }) => {
  return (
    <Card spacing="small">
      <CardContent>
        <ProductImage product={product} />
      </CardContent>
      <CardContent>
        <ProductTitle product={product} />
        <Text variant="body2">
          {product.purchasable ? (
            product.prices[0]?.price ? (
              <Price
                amount={product.prices[0].price.amount}
                currency={product.prices[0].price.currency.enum_value}
              />
            ) : null
          ) : (
            <Discount amount={product.purchaseExternalDiscount} />
          )}
        </Text>
      </CardContent>
    </Card>
  )
}

const ProductImage = ({ product }) => {
  return (
    <Image
      imageFile={product.imageFile}
      size="w640"
      alt=""
      className="w-full h-48 object-contain"
    />
  )
}

const ProductTitle = ({ product }) => {
  return (
    <Text variant="headline5" className="text-dark line-clamp-2">
      {product.title}
    </Text>
  )
}
